import { useState } from "react";
import axios from "axios";

const useFetchExecutionArnResults = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const fetchExecutionArnResults = async (executionArn) => {
    setIsLoading(true);
    setIsError(false);
    setError(null);

    try {
      const response = await axios.post(process.env.REACT_APP_API_GATEWAY_URL_STEP_FUNCTIONS, {
        executionArn,
      });

      setData(response);
      setIsLoading(false);

      const parsedOuter = JSON.parse(response.data.body);

      // Return the full parsed object so frontend can access paymentIntentId
      return parsedOuter;
    } catch (err) {
      setIsLoading(false);
      setIsError(true);
      setError(err);
      console.error("Error fetching execution ARN results:", err);
      return null;
    }
  };

  return { fetchExecutionArnResults, isLoading, isError, error, data };
};

export default useFetchExecutionArnResults;
